import { useQuery } from "@tanstack/react-query";
import { usePermissions } from "@/hooks/use-permissions";
import { useFeatureGates, gateBlockForRoute } from "@/hooks/use-feature-gates";
import { routeMenuLockKey } from "@/lib/upgrade-info";
import { apiRequest } from "@/lib/queryClient";

export function useBankFeedAccess() {
  const permissions = usePermissions();
  const gates = useFeatureGates();
  const tierLocks = useQuery<{ deniedKeys: string[] }>({
    queryKey: ["/api/app/menu-tier-locks/denied"],
    queryFn: async () => (await apiRequest("GET", "/api/app/menu-tier-locks/denied")).json(),
    staleTime: 60_000,
    retry: false,
    enabled: !permissions.isLoading && permissions.canView("financials"),
  });
  const key = routeMenuLockKey("/app/financials/settings");
  const tierDenied = !!key && tierLocks.data?.deniedKeys.includes(key);
  const loaded = !permissions.isLoading && gates.loaded && tierLocks.isSuccess;
  const failed = gates.failed || tierLocks.isError;
  const enabled = loaded && !failed && !tierDenied && permissions.canView("financials") &&
    !gateBlockForRoute(gates.byKey, "/app/financials/settings");
  return { enabled, canEdit: enabled && permissions.canEdit("financials"), loaded, failed, tierDenied };
}
